import React, { useRef } from 'react';
import { Collapse } from 'antd';
import moment from 'moment';
import { ReactComponent as Arrow } from '../../../../../../../../resources/images/svg/emptyArrow.svg';
import PurchasedTicketPanelHeader from './components/PurchasedTicketPanelHeader';
import PurchasedTicketPanelContent from './components/PurchasedTicketPanelContent';
import useTranslation from '../../../../../../../hooks/translation/useTranslation';
import { ReactComponent as Download } from '../../../../../../../../resources/images/svg/download.svg';

const { Panel } = Collapse;
const tableTitleClass = 'm-0 items-center flex text-base';

function DesktopTicketsList({
  tickets,
  title,
  handleDownloadTicket,
  handleTicketRefund,
  expired = false,
  handleAdditionalServices,
}) {
  const { trans } = useTranslation();
  const titlesRef = useRef(null);

  const genExtra = (ticketsGroup) => (
    <button
      type="button"
      className={`flex gap-3 items-center border-0 bg-transparent cursor-pointer ${!ticketsGroup?.find((ticket) => !ticket?.is_refunded) && 'hidden'
      }`}
      onClick={(event) => {
        handleDownloadTicket(ticketsGroup);
        event.stopPropagation();
      }}
    >
      <Download />
      <h3 className={`${tableTitleClass} hidden xl:flex`}>
        {trans('download')}
      </h3>
    </button>
  );

  const getStatus = (ticketsGroup) => {
    if (ticketsGroup?.find((ticket) => ticket?.is_refunded)) {
      return 'canceled-tickets';
    }
    return moment().diff(ticketsGroup?.[0]?.departure_date) > 0
      ? 'expired-tickets'
      : 'active-tickets';
  };
  return (
    <div className="flex flex-col gap-5">
      <h2 className="font-big">{title}</h2>
      <div className="flex gap-5 px-[86px] max-w-[1124px]" ref={titlesRef}>
        <h3 className={`${tableTitleClass} w-[7.6%]`}>{trans('code')}</h3>
        <h3 className={`${tableTitleClass} w-[12%]`}>{trans('train')}</h3>
        <h3 className={`${tableTitleClass} w-[20.3%]`}>
          {trans('start_station')}
        </h3>
        <h3 className={`${tableTitleClass} w-[20.5%]`}>
          {trans('destination_station')}
        </h3>
        <h3 className={`${tableTitleClass} w-[12.2%]`}>
          {trans('departure_date')}
        </h3>
        <h3 className={`${tableTitleClass} w-[12.3%]`}>
          {trans('arrival_date')}
        </h3>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex flex-col">
          <Collapse
            className="tickets-list-collapse"/* eslint-disable-next-line react/no-unstable-nested-components */
            expandIcon={({ isActive }) => (
              <div className="h-[36px] w-[36px] rounded-[50%] !flex justify-center items-center">
                <Arrow
                  style={{ transform: `rotate(${isActive ? '180deg' : '0deg'})` }}
                />
              </div>
            )}
          >
            {tickets && Object.values(tickets)?.map((ticketsGroup) => (
              <Panel
                header={(
                  <PurchasedTicketPanelHeader
                    titlesRef={titlesRef}
                    ticketsGroup={ticketsGroup}
                  />
        )}
                key={ticketsGroup[0].id}
                className={`tickets-list-collapse-panel ${getStatus(ticketsGroup)}`}
                extra={genExtra(ticketsGroup)}
              >
                <PurchasedTicketPanelContent
                  tickets={ticketsGroup}
                  handleTicketRefund={handleTicketRefund}
                  handleAdditionalServices={handleAdditionalServices}
                  expired={expired}
                />
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    </div>
  );
}

export default DesktopTicketsList;
